<template>
  <div>
    <v-dialog
      v-model="confirmDialogVisible"
      :persistent="Boolean(currentRequest && currentRequest.persistent)"
      :max-width="(currentRequest && currentRequest.width) || 400"
      @keydown.esc="cancelConfirm"
    >
      <v-card v-if="currentRequest && currentRequest.type === 'confirm'">
        <v-toolbar :color="currentRequest.color || 'primary'" density="compact" flat>
          <v-toolbar-title>
            <span class="confirm-dialog-title">
              <svg-icon
                v-if="currentRequest.titleIcon"
                type="mdi"
                :path="currentRequest.titleIcon"
                :size="22"
                class="confirm-dialog-title-icon"
              />
              <span>{{ currentRequest.title || '확인' }}</span>
            </span>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-4">
          <div v-if="currentRequest.icon" class="d-flex justify-center mb-4">
            <svg-icon type="mdi" :path="currentRequest.icon" :size="36" />
          </div>
          <p v-if="currentRequest.html" class="mb-0" v-html="currentRequest.message"></p>
          <p v-else class="mb-0">{{ currentRequest.message }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn :color="currentRequest.buttonFalseColor || 'grey'" variant="text" @click="cancelConfirm">
            {{ currentRequest.buttonFalseText || '취소' }}
          </v-btn>
          <v-btn :color="currentRequest.buttonTrueColor || 'primary'" variant="text" @click="confirmConfirm">
            {{ currentRequest.buttonTrueText || '확인' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <CustomPromptDialog
      v-model="promptDialogVisible"
      :options="currentRequest || {}"
      @confirm="confirmPrompt"
      @cancel="cancelPrompt"
    />
  </div>
</template>

<script>
import CustomPromptDialog from '@/components/CustomPromptDialog.vue';
import { closeActiveDialog, subscribeDialogService } from '@/utils/dialogService';

export default {
  name: 'DialogServiceHost',
  components: {
    CustomPromptDialog,
  },
  data() {
    return {
      currentRequest: null,
      unsubscribe: null,
    };
  },
  computed: {
    confirmDialogVisible: {
      get() {
        return Boolean(this.currentRequest && this.currentRequest.type === 'confirm');
      },
      set(value) {
        if (!value) {
          this.cancelConfirm();
        }
      },
    },
    promptDialogVisible: {
      get() {
        return Boolean(this.currentRequest && this.currentRequest.type === 'prompt');
      },
      set(value) {
        if (!value) {
          this.cancelPrompt();
        }
      },
    },
  },
  created() {
    this.unsubscribe = subscribeDialogService((request) => {
      this.currentRequest = request;
    });
  },
  beforeUnmount() {
    this.unsubscribe?.();
  },
  methods: {
    confirmConfirm() {
      closeActiveDialog(true);
    },
    cancelConfirm() {
      if (this.currentRequest && this.currentRequest.type === 'confirm') {
        closeActiveDialog(false);
      }
    },
    confirmPrompt(value) {
      closeActiveDialog(value);
    },
    cancelPrompt() {
      if (this.currentRequest && this.currentRequest.type === 'prompt') {
        closeActiveDialog(null);
      }
    },
  },
};
</script>

<style scoped>
.confirm-dialog-title {
  display: flex;
  align-items: center;
  gap: 0.5em;
}

.confirm-dialog-title-icon {
  flex: 0 0 auto;
}
</style>

